import { useEffect, useRef, useState } from 'react';

import { PdfViewerClient } from '../client/pdfViewerClient';
import { OutlineEntry, OutlineItem } from '../types';

export type OutlineState =
    | { status: 'idle' | 'loading' | 'failed' }
    | { status: 'ready'; items: OutlineEntry[] };

const withIds = (items: OutlineItem[], prefix: string): OutlineEntry[] => items.map((item, position) => {
    const id = `${prefix}${position}`;
    return { ...item, id, children: withIds(item.children, `${id}.`) };
});

const useOutline = (client: PdfViewerClient, enabled: boolean): OutlineState => {
    const [state, setState] = useState<OutlineState>({ status: 'idle' });
    const isRequestedRef = useRef<boolean>(false);

    useEffect(() => {
        if (!enabled || isRequestedRef.current) {
            return;
        }
        isRequestedRef.current = true;
        setState({ status: 'loading' });
        client.getOutline()
            .then((items) => setState({ status: 'ready', items: withIds(items, '') }))
            .catch(() => setState({ status: 'failed' }));
    }, [client, enabled]);

    return state;
};

export default useOutline;
